module.exports = __webpack_public_path__ + "img/introduction02_top_02.6f145901.png";